import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-4xl" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "font-semibold flex items-center gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-arrow-down"
}
const _hoisted_7 = { class: "flex flex-col items-center justify-center gap-2 md:flex-row" }
const _hoisted_8 = { class: "font-normal text-gray-500" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-stopwatch" }, null, -1)
const _hoisted_10 = { class: "flex w-full items-center justify-between gap-2 md:w-auto md:justify-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import CButton from "@/components/Button.vue";
import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import ServiceForm from "./serviceForm.vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { useConfirm } from "primevue/useconfirm";
import PConfirmDialog from "primevue/confirmdialog";
import { cloneDeep } from "lodash";
import { useNotify } from "@/composables/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const sortByStartingAt = (a: any, b: any) => {
  const [aHours, aMins] = a.startingAt.split(":").map(Number);
  const [bHours, bMins] = b.startingAt.split(":").map(Number);

  if (aHours < bHours) {
    return -1;
  } else if (aHours > bHours) {
    return 1;
  } else {
    // hours are equal, compare minutes
    if (aMins < bMins) {
      return -1;
    } else if (aMins > bMins) {
      return 1;
    } else {
      return 0;
    }
  }
};

const confirm = useConfirm();
const { t } = useI18n();
const { successToast, errorToast } = useNotify({ t });

const store = useStore();
const activeService = ref<number>(-1);
const isShowCreateNew = ref(false);
const toggleCreateNew = (show: boolean) => {
  isShowCreateNew.value = show;
  if (isShowCreateNew.value) {
    closeAll();
  }
};
const canShowEditButtonsOnServices = computed(() => {
  return activeService.value < 0 && !isShowCreateNew.value;
});

const retrievePos = async () => {
  await store.dispatch("pos/RETRIEVE");
};

onBeforeMount(async () => {
  await retrievePos();
});
const selectService = (index: number) => {
  activeService.value = index;
};
const closeAll = () => {
  activeService.value = -1;
};

const createAService = async (service: any) => {
  try {
    await store.dispatch("service/CREATE_SERVICE", service);
    toggleCreateNew(false);
    closeAll();
    successToast({ title: t("service"), detail: t("createdSuccessfully") });

    await retrievePos();
  } catch (e: any) {
    errorToast({ title: t("service"), error: e.message });
  }
};

const updateAService = async (service: any) => {
  try {
    await store.dispatch("service/UPDATE_SERVICE", service);
    closeAll();
    successToast({ title: t("service"), detail: t("updatedSuccessfully") });
    await retrievePos();
  } catch (e: any) {
    errorToast({ title: t("service"), error: e.message });
  }
};

const services = computed<any[]>(() =>
  cloneDeep(store.getters["pos/services"]).sort(sortByStartingAt)
);

const deleteService = (service: any) => {
  confirm.require({
    message: `${t("deletingService")} ${service.name ?? ""} `,
    header: t("confirmation"),
    icon: "pi pi-exclamation-triangle",
    accept: async () => {
      try {
        await store.dispatch("service/DELETE_SERVICE", service);
        closeAll();
        successToast({ title: t("service"), detail: t("deletedSuccessfully") });

        await retrievePos();
      } catch (e: any) {
        errorToast({ title: t("service"), error: e?.message });
      }
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_unref(PConfirmDialog)),
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("services")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCreateNew(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("createNew")), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, { name: "toggleable-content" }, {
          default: _withCtx(() => [
            (isShowCreateNew.value)
              ? (_openBlock(), _createBlock(ServiceForm, {
                  key: 0,
                  class: "p-5 border rounded shadow",
                  onCancel: _cache[1] || (_cache[1] = ($event: any) => (toggleCreateNew(false))),
                  onSave: createAService
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Accordion), {
        activeIndex: activeService.value,
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"]))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service, serviceIndex) => {
            return (_openBlock(), _createBlock(_unref(AccordionTab), {
              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"])),
              key: serviceIndex
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
                  class: "flex flex-col md:flex-row justify-between items-center w-full gap-y-2 p-5"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(service.name), 1),
                    (serviceIndex === activeService.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createTextVNode(" (" + _toDisplayString(service.startingAt) + "-" + _toDisplayString(service.endingAt) + ") ", 1),
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(service.duration), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("i", {
                        class: _normalizeClass([{ invisible: !_unref(canShowEditButtonsOnServices) }, "pi pi-pencil hover:cursor-pointer"]),
                        onClick: ($event: any) => (selectService(serviceIndex))
                      }, null, 10, _hoisted_11),
                      _createElementVNode("i", {
                        class: "pi pi-trash hover:cursor-pointer",
                        onClick: ($event: any) => (deleteService(service))
                      }, null, 8, _hoisted_12)
                    ])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(ServiceForm, {
                  "is-update": "",
                  service: service,
                  onCancel: _cache[3] || (_cache[3] = ($event: any) => (closeAll())),
                  onSave: updateAService
                }, null, 8, ["service"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ])
  ]))
}
}

})